import { HashRouter, Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import Routes from './routes';
import AppShell from '../../AppShell';
import LoginPage from '../../features/auth/ui/LoginPage';
import ForgotPasswordPage from '../../features/auth/ui/ForgotPasswordPage';
import HomePage from '../../features/home/ui/HomePage';
import { TaskTimesheetsPage } from '../../features/tasks';
import { useAuth } from '../../features/auth/logic/authProvider';

const AppRouter = () => {
  const { isAuthenticated } = useAuth();

  return (
    <HashRouter>
      <AppShell>
        <ReactRoutes>
          <Route
            path={Routes.home}
            element={isAuthenticated ? <HomePage /> : <Navigate to={Routes.login} replace />}
          />
          <Route
            path={Routes.taskTimesheetsPattern}
            element={isAuthenticated ? <TaskTimesheetsPage /> : <Navigate to={Routes.login} replace />}
          />
          <Route
            path={Routes.login}
            element={isAuthenticated ? <Navigate to={Routes.home} replace /> : <LoginPage />}
          />
          <Route
            path={Routes.forgotPassword}
            element={isAuthenticated ? <Navigate to={Routes.home} replace /> : <ForgotPasswordPage />}
          />
          <Route
            path={Routes.splash}
            element={<Navigate to={isAuthenticated ? Routes.home : Routes.login} replace />}
          />
          <Route
            path="*"
            element={<Navigate to={isAuthenticated ? Routes.home : Routes.login} replace />}
          />
        </ReactRoutes>
      </AppShell>
    </HashRouter>
  );
};

export default AppRouter;
